import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

declare interface RouteInfo {
  text1?: string;
  text2?: string;
  text3?: string;
  img?: string;
  alt?: string;
  name?: string;
  title?: string;
  description?: string;
  city?: string;
}

export const CHCCFoundationContent: RouteInfo[] = [
  {
    text1:
      'To create, develop and provide educational and economic development programs to increase adult leadership for CHCC and its members.',
    text2:
      'To provide scholarship opportunities for qualified students to attend educational institutions to study business and economic development.',
    text3:
      "To attract and receive contributions of cash, securities and property of any other kind or description from individuals, corporations and other business or governmental entities to establish and maintain the Foundation's funds.",
  },
];
export const BoardPictures: RouteInfo[] = [
  {
    img: '../../../assets/images/Brd_Photos/J_Placensia.png',
    alt: 'Jose Plascencia Picture',
    name: 'Jose Plascencia',
    title: 'Chair',
    description: 'Allstate Kings Canyon Insurance Group LLC',
    city: ' Reedley, CA',
  },
  {
    img: '../../../assets/images/CHCCFoundation/Sophia Garcia.png',
    alt: 'Sophia Garcia Picture',
    name: 'Sophia Garcia',
    title: 'Vice Chair',
    description: 'Verizon',
    city: 'Sacramento, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/J_Canete.jpeg',
    alt: 'Julian Canete Picture',
    name: 'Julian Cañete',
    title: 'President & CEO ',
    description: 'California Hispanic Chambers of Commerce',
    city: 'Sacramento, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/R_Hernandez.png',
    alt: 'Raul Hernandez Picture',
    name: 'Raul Hernandez',
    title: 'Treasurer',
    description: 'Hood & Strong, LLP',
    city: 'San Francisco, CA',
  },
  {
    img: '../../../assets/images/Brd_Photos/J_Castro.png',
    alt: 'Dr. Judy Castro Picture',
    name: 'Dr. Judy Castro',
    title: 'Secretary',
    description: 'Pacific Oaks University',
    city: 'San Jose, CA',
  },

];
export const DirectorsRow1: RouteInfo[] = [
  {
    img: '../../../assets/images/CHCCFoundation/D_Alanis.png',
    alt: 'David Alanis Picture',
    name: 'David Alanis',
    title: 'Board Member',
    description: 'California Employment Development Department',
    city: 'Bakersfield, CA',
  },
  {
    img: '../../../assets/images/CHCCFoundation/D_Betancourt.png',
    alt: 'David Betancourt Picture',
    name: 'David Betancourt',
    title: 'Board Member',
    description: 'Aetna',
    city: 'Los Angeles, CA',
  },
  {
    img: '../../../assets/images/CHCCFoundation/LawrenceGarcia.png',
    alt: 'Lawrence Garcia Picture',
    name: 'Lawrence Garcia',
    title: 'Board Member',
    description: 'AmeriGuard Private Security',
    city: 'Fresno, CA',
  },
  {
    img: '../../../assets/images/CHCCFoundation/DK.png',
    alt: 'Dennis King Picture',
    name: 'Dennis King',
    title: 'Board Member',
    description: 'Silicon Valley Hispanic Chamber of Commerce',
    city: 'San Jose, CA',
  },
  {
    img: '../../../assets/images/CHCCFoundation/S_Aguilera_Marrero.png',
    alt: 'Suzanna Marrero Picture',
    name: 'Suzanna Marrero',
    title: 'Board Member',
    description:
      'Foundation Chair of Tulare Kings Hispanic Chamber of Commerce',
    city: 'Visalia, CA',
  },
  {
    img: '../../../assets/images/CHCCFoundation/Gabby Mello.png',
    alt: 'Gabriela Mello Picture',
    name: 'Gabriela Mello ',
    title: 'Board Member',
    description: 'Citizens Business Bank',
    city: 'Bakerfield, CA',
  },

  {
    img: '../../../assets/images/CHCCFoundation/R_Nogeuira.png',
    alt: 'Rick Nogueira Picture',
    name: 'Rick Nogueira',
    title: 'Board Member',
    description: 'Chase',
    city: 'Irvine, CA',
  },
  {
    img: '../../../assets/images/CHCCFoundation/MariaUrena.png',
    alt: 'Maria Urena Picture',
    name: 'Maria Urena',
    title: 'Board Member',
    description: 'King Automotive Services, Inc.',
    city: 'Moreno Valley, CA',
  },

  {
    img: '../../../assets/images/CHCCFoundation/R_Vasquez.png',
    alt: 'Ray Vasquez Picture',
    name: 'Ray Vasquez',
    title: 'Board Member',
    description: 'Bank of America',
    city: 'Pasadena, CA',
  },
];

@Component({
    selector: 'app-chccfoundation',
    templateUrl: './chccfoundation.component.html',
    styleUrls: ['./chccfoundation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CHCCFoundationComponent implements OnInit {
  mainTitle = 'CHCC Foundation';
  lists: any = [];
  pictures: any = [];
  directors: any = [];

  constructor() {}

  ngOnInit(): void {
    this.lists = CHCCFoundationContent.filter((list) => list);
    this.pictures = BoardPictures.filter((picture) => picture);
    this.directors = DirectorsRow1.filter((director) => director);
  }
}
